import script from "./seize.vue?vue&type=script&setup=true&lang=js"
export * from "./seize.vue?vue&type=script&setup=true&lang=js"

import "./seize.vue?vue&type=style&index=0&id=5d77bb30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d77bb30"]])

export default __exports__